import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type EmailTemplateView, type EmailTemplateState } from "../../types/state";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type EmailTemplateFormFields, type BodyContent } from "../../Details/types";

const initialState: EmailTemplateState = {
  emailTemplate: {
    subject: "",
    previewText: "",
    senderName: "",
    senderEmail: "",
    html: "",
    contentUrlWithSas: "",
  },
  isLoading: false,
  isLoaded: false,
  isLoadingContent: false,
  isContentLoaded: false,
};

const emailTemplateSlice = createSlice({
  name: `${ReducerNamespaceTypes.Library}/${ReducerEntityPrefixTypes.ThreatDefenceCampaigns}/emailTemplate`,
  initialState,
  reducers: {
    saveEmailTemplate(state: EmailTemplateState, action: PayloadAction<EmailTemplateFormFields>) {
      state.emailTemplate.subject = action.payload.subject;
      state.emailTemplate.previewText = action.payload.previewText;
      state.emailTemplate.senderName = action.payload.senderName;
      state.emailTemplate.senderEmail = action.payload.senderEmail;
      state.emailTemplate.html = action.payload.html;
      state.emailTemplate.contentUrlWithSas = action.payload.contentUrlWithSas;
    },
    clearEmailTemplate: () => initialState,
    reqEmailTemplate(state: EmailTemplateState) {
      state.isLoading = true;
    },
    gotEmailTemplate(state: EmailTemplateState, action: PayloadAction<EmailTemplateView>) {
      const { html, contentUrlWithSas, ...rest } = action.payload;

      state.isLoaded = true;
      state.isLoading = false;
      state.emailTemplate = { ...state.emailTemplate, ...rest };
    },
    errEmailTemplate(state: EmailTemplateState, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    reqContent(state) {
      state.isLoadingContent = true;
    },
    gotContent(state, action: PayloadAction<BodyContent>) {
      state.isLoadingContent = false;
      state.isContentLoaded = true;
      state.emailTemplate.html = action.payload.html;
      state.emailTemplate.contentUrlWithSas = action.payload.contentUrlWithSas;
    },
    errContent(state, action: PayloadAction<Error>) {
      state.isLoadingContent = false;
      state.error = action.payload;
    },
    setIsContentLoaded(state, action: PayloadAction<boolean>) {
      state.isContentLoaded = action.payload;
    },
  },
});

export const {
  saveEmailTemplate,
  clearEmailTemplate,
  reqContent,
  gotContent,
  errContent,
  setIsContentLoaded,
  reqEmailTemplate,
  gotEmailTemplate,
  errEmailTemplate,
} = emailTemplateSlice.actions;

export default emailTemplateSlice.reducer;
